module.exports = __webpack_public_path__ + "img/screenshot-2.d1d07b78.png";